"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideShowGalleryPropertiesSchema = void 0;
var yup = __importStar(require("yup"));
var schemaUtils_1 = require("../core/schemaUtils");
exports.SlideShowGalleryPropertiesSchema = schemaUtils_1.createPropertiesSchema('SlideShowGalleryProperties', yup.object({
    imageMode: yup
        .string()
        .oneOf(['clipImage', 'flexibleHeight', 'flexibleWidthFixed'])
        .default('clipImage'),
    transition: yup
        .string()
        .oneOf(['none', 'swipeVertical', 'swipeHorizontal', 'crossfade', 'outIn'])
        .default('swipeHorizontal')
        .meta({
        description: "Transition between items of the gallery",
    }),
    autoplayInterval: yup
        .number()
        .min(0)
        .max(30)
        .default(5)
        .meta({
        description: "Autoplay interval",
    }),
    autoplay: yup.boolean().default(false),
    transDuration: yup
        .number()
        .min(0)
        .max(5)
        .default(1)
        .meta({
        description: "Duration of the transition in sec",
    }),
    bidirectional: yup
        .boolean()
        .default(true)
        .meta({
        description: "Decides whether the transition direction reflects Prev/Next",
    }),
    reverse: yup
        .boolean()
        .default(false)
        .meta({
        description: "If bidirectional, inverts the direction of transitions",
    }),
    showAutoplay: yup.boolean().default(true),
    showNavigation: yup.boolean().default(true),
    showCounter: yup.boolean().default(true),
    expandEnabled: yup.boolean().default(true),
    goToLinkText: yup
        .string()
        .nullable()
        .default('Go to link'),
    galleryImageOnClickAction: yup
        .string()
        .oneOf(['disabled', 'zoomMode', 'goToLink'])
        .default('zoomMode'),
    alignText: yup
        .string()
        .oneOf(['left', 'right'])
        .default('left'),
}));
//# sourceMappingURL=SlideShowGalleryProperties.schema.js.map